import React, { useEffect, useState } from "react";
import LocalizedLink from 'helpers/LocalizeLink';
import { useTranslation } from 'react-i18next';
import { useSelector, useStore } from 'react-redux';
import { setCart } from 'state/actions';

const FinishWidget = (props) => {
  const { t } = useTranslation();
  const { dispatch } = useStore();
  const [orderStatus, setOrderStatus] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const currency = useSelector((store) => store.currency);
  const cart = useSelector((store) => store.cart);
  const [total, setTotal] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  let finish = null;

  if (props.items.length > 0) finish = props.items[0];

  const remove = () => {
    let cartItem = cart.filter((cart_item, index) => {
      const product_id = parseInt(cart_item.id);
      let res = true;
      if (finish) {
        finish.purchases.forEach((purchase) => {
          if (parseInt(purchase.product_id) === product_id) {
            res = false;
          }
        });
      };
      return res;
    });
    dispatch(setCart(cartItem));
  };

  const PaySucces = () => {
    const { t } = useTranslation();
    return (
      <div className="text-center mb-4">
        <i className="check d-block mx-auto mb-3"></i>
        <p className="text-darkgreen text-semibold text-medium mb-2">{t('errors.err_congratulations')}</p>
        <p className="text-darkgreen text-semibold text-medium">{t('errors.err_payment_recieved')}</p>
      </div>);

  };

  const PayCanceled = () => {
    const { t } = useTranslation();
    return (
      <div className="text-center mb-4">
        <i className="cancel d-block mx-auto mb-3"></i>
        <p className="text-darkred text-semibold text-medium">{t('errors.Payment canceled')}</p>
      </div>);

  };

  const PayNotFound = () => {
    const { t } = useTranslation();
    return (
      <div className="text-center mb-4">
        <i className="cancel d-block mx-auto mb-3"></i>
        <p className="text-darkred text-semibold text-medium">{t('errors.err_insuficient_founds')}</p>
      </div>);

  };

  const PayProcessing = () => {
    const { t } = useTranslation();
    return (
      <div className="text-center mb-4">
        <i className="warning d-block mx-auto mb-3"></i>
        <p className="text-gold text-semibold text-medium">{t('errors.Waiting for payment')}</p>
      </div>);

  };

  useEffect(() => {
    remove();

    if (!orderStatus && finish?.details)
      var order = finish.details.find((order) => order.field === "order_id");
    setOrderId(order?.value);

    if (finish) {
      setTotal(finish.purchases.reduce((accumulator, currentItem) => {
        return accumulator + currentItem.price * currentItem.quantity;
      }, 0).toFixed(2));

      finish.details.forEach((item) => {
        if (item.field === "status") {
          switch (item?.value) {
            case 'init':
              setOrderStatus(<PayProcessing />);
              break;
            case 'canceled':
              setOrderStatus(<PayCanceled />);
              break;
            case 'completed':
              setIsCompleted(true);
              setOrderStatus(<PaySucces />);
              break;
            case 'failed':
              setOrderStatus(<PayNotFound />);
              break;
            case 'holding':
              setOrderStatus(null);
              break;
            case 'processing':
              setOrderStatus(<PayProcessing />);
              break;
            case 'refunded':
              setOrderStatus(null);
              break;
            default:
              setOrderStatus(null);
          }
        }
      });
    }
  }, []);

  return (
    <div className="transaction mx-auto mb-5 px-3">
      {orderStatus}
      <div data-test-id="finish-receipt" className={"transaction-report p-3 mb-4" + (orderStatus === null || orderStatus === undefined ? " mt-5" : "")}>
        <div id={'printBox'}>
          <p className="text-semibold mb-3">{t('labels.order_details')}</p>
          {
            finish.details.map((item, key) => {
              return (
                <div key={'items_' + key} className="row mb-2">
                  <p className="col-8 text-medium">{item?.name}:</p>
                  <p className="col-4 text-medium text-right">{item?.value}</p>
                </div>);

            })
          }
          <div className="separator my-3"></div>
          {
            finish.purchases.map((item, key) => {
              return (
                <div key={'items_' + key} className="row align-items-center mb-2">
                  <p className="col-8 text-small">{item?.quantity} x {item.name}</p>
                  <p className="col-4 text-small text-right">{currency?.symbol} {item.quantity * item.price}</p>
                </div>);

            })
          }
          <div className="separator my-3"></div>
          <div className="row">
            <p className="col-8 text-semibold">{t('labels.total_price')}:</p>
            <p className="col-4 text-green text-bold text-right">{currency.symbol}
              {total}
            </p>
          </div>
          {
            finish.type === 'subscription' ?
              <p className="text-medium text-sm-small mt-4" dangerouslySetInnerHTML={{ __html: t("To deactivate the automatic renew") }}></p> : null
          }
        </div>
        {total > 0 && isCompleted ?
          <a href={'/marketplace/api/content/finish/' + orderId + '?reportReceipt=1'} data-test-id="finish-download-btn" className="text-green text-semibold text-decoration-none mt-5 d-flex justify-content-center justify-content-sm-start align-items-center" target="_blank" rel="noreferrer">
            <i className="pdf d-block mr-2"></i>{t("Download receipt")}
          </a> : null}
      </div>
      <LocalizedLink to={'/'} dti="finish-back-to-home" className="btn noshadow back-arrow h-42 mx-auto px-12 d-flex justify-content-center align-items-center max-w-400px">
        {t('buttons.btn_back_home')}
      </LocalizedLink>
    </div>);

};

export default FinishWidget;